import axios from "../../../js/project-axios.js";

const tree = appId => {
    return axios.get("/servicer/permission/tree", {
        params: {
            appId
        }
    });
};

const add = (appId, permission) => {
    return axios.post("/servicer/permission/add", permission, {
        params: {
            appId
        }
    });
};

const update = permission => {
    return axios.post("/servicer/permission/update", permission);
};

const remove = permission => {
    return axios.post("/servicer/permission/remove", permission);
};

const move = (appId, permission) => {
    return axios.post('/servicer/permission/move', permission, {
        params: {
            appId
        }
    });
};

export default {
    tree,
    add,
    update,
    remove,
    move
};